import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceArea,
  ReferenceLine,
} from 'recharts';

import { formatDecimal, persianDigits } from '@/features/reports/lib/format';
import { fa } from '../i18n/fa';
import ChartCard from './ChartCard';
import { ChartLegend, COLORS, rtlXAxisProps, rtlYAxisProps, chartTooltipStyle } from './chartTheme';

export default function RetentionChart({ retention, chain, tolerancePct }) {
  const rows = retention.labels.map((code, i) => {
    const st = chain?.stages.find((s) => s.code === code);
    return {
      code,
      label: fa.stageName(code),
      average: retention.average[i] && +retention.average[i].toFixed(1),
      chain: st?.verified && st.qty ? +((st.qty / chain.baseline) * 100).toFixed(1) : null,
    };
  });
  return (
    <ChartCard
      className="tr-retention-card"
      title={fa.charts.retention.title}
      note={fa.charts.retention.note}
      empty={rows.length === 0}
    >
      <ResponsiveContainer>
        <ComposedChart data={rows} margin={{ top: 18, right: 18, left: 22, bottom: 14 }}>
          <CartesianGrid stroke={COLORS.grid} strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="label"
            {...rtlXAxisProps}
            interval={0}
            angle={0}
            height={48}
            tick={{ fontSize: 12 }}
          />
          <YAxis
            {...rtlYAxisProps}
            domain={[60, 105]}
            tickFormatter={(v) => persianDigits(v)}
            tick={{ fontSize: 12 }}
          />
          {Number.isFinite(tolerancePct) && (
            <ReferenceArea
              y1={100 - tolerancePct}
              y2={100 + tolerancePct}
              fill={COLORS.amber}
              fillOpacity={0.12}
              strokeOpacity={0}
            />
          )}
          <ReferenceLine
            y={100}
            stroke={COLORS.muted}
            strokeDasharray="5 4"
            label={{
              value: fa.charts.retention.reference,
              position: 'insideTopLeft',
              fill: COLORS.muted,
              fontSize: 12,
            }}
          />
          <Tooltip
            contentStyle={{ ...chartTooltipStyle, padding: '12px 16px', fontSize: 14 }}
            formatter={(value, name) => [`${formatDecimal(value, 1)}٪`, name]}
          />
          <ChartLegend />
          <Bar dataKey="average" name={fa.charts.retention.avg} fill={COLORS.primary} fillOpacity={0.55} radius={[6, 6, 0, 0]} />
          <Line
            dataKey="chain"
            name={fa.chain.selectedChain}
            stroke={COLORS.muted}
            strokeWidth={2}
            dot={{ r: 6 }}
            activeDot={{ r: 9 }}
            connectNulls
          />
        </ComposedChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
